
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M97 50c0 25.957-21.043 47-47 47S3 75.957 3 50 24.043 3 50 3s47 21.043 47 47z","stroke-width":"6","fill":"none"}}),_c('path',{attrs:{"d":"M32.289 47.691c4.918 0 8.905 1.785 8.905-3.133a8.905 8.905 0 10-17.81 0c0 4.918 3.987 3.133 8.905 3.133zm35.324 0c4.918 0 8.905 1.785 8.905-3.133a8.905 8.905 0 10-17.81 0c0 4.918 3.987 3.133 8.905 3.133zm.527 13.853c0 17.792-36.28 17.388-36.28 0 5.772 1.649 30.508 1.649 36.28 0z","data-fill-colored":"true"}})])
          )
        }
      }
    